// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';



require( 'datatables.net-dt' )

require('./grips.notification-0.1.0.js');
require('./candidate');
require('./candidates');
require('./event');
require('./events');
require('./event-group');
require('./event-groups');
require('./org');
require('./orgs');
require('./cvs');

$(document).ready(function () {

    $('#radioBtn a').on('click', function(){
        var sel = $(this).data('title');
        var tog = $(this).data('toggle');
        $('#'+tog).prop('value', sel);

        $('a[data-toggle="'+tog+'"]').not('[data-title="'+sel+'"]').removeClass('active').addClass('notActive');
        $('a[data-toggle="'+tog+'"][data-title="'+sel+'"]').removeClass('notActive').addClass('active');
    })

    let uploadArea = $('.upload-area');

    uploadArea.on('dragenter', function () {
        uploadArea.addClass('dragover');
    });

    uploadArea.on('dragleave', function () {
        uploadArea.removeClass('dragover');
    });
})
